import API from "../../Api/Api";
import store from "../store";

export const getFavorites =
  (collectionId, collectionName, signal) => async (dispatch) => {
    try {
      const user = store.getState()?.userReducer?.user;
      const { data } = await API.get(`/api/users/${user.id}`, {
        params: {
          fields: [
            "birthdate",
            "email",
            "firstName",
            "lastName",
            "occupation",
            "phoneNumber",
            "userRole",
          ],
          populate: {
            favorites: {
              filters: {
                [collectionName]: {
                  id: {
                    $eq: collectionId,
                  },
                },
              },
              populate: {
                attachments: {
                  populate: {
                    file: true,
                  },
                },
                user: {
                  populate: {
                    photo: true,
                  },
                },
              },
            },
          },
        },
        signal,
      });

      dispatch({
        type: "GET_FAVORITES",
        payload: data?.favorites,
      });
    } catch (error) {
      if (error.name === "CanceledError") return;
      console.log(error);
    }
  };

export const addFavorite = (id) => async (dispatch) => {
  try {
    const user = store.getState()?.userReducer?.user?.id;

    const { data: comment } = await API.get(`api/comments/${id}`, {
      params: {
        populate: {
          favoredBy: true,
        },
      },
    });

    await API.put(`api/comments/${id}`, {
      data: {
        favoredBy: [
          ...(comment?.data?.attributes?.favoredBy?.data?.map((f) => +f?.id) ||
            []),
          user,
        ],
      },
    });

    const { data } = await API.get(`api/comments/${id}`, {
      params: {
        populate: {
          attachments: {
            populate: {
              file: true,
            },
          },
          user: {
            populate: {
              photo: true,
            },
          },
        },
      },
    });

    dispatch({
      type: "ADD_FAVORITE",
      payload: {
        id: data?.data?.id,
        ...(data?.data?.attributes || {}),
        user: {
          id: data?.data?.attributes?.user?.id,
          ...(data?.data?.attributes?.user?.data?.attributes || {}),
        },
        attachments: data?.data?.attributes?.attachments?.data?.map(
          (attachment) => ({
            id: attachment.id,
            ...(attachment?.attributes || {}),
            file: {
              id: attachment?.attributes?.file?.data?.id,
              ...(attachment?.attributes?.file?.data?.attributes || {}),
            },
          }),
        ),
      },
    });
  } catch (error) {
    console.log(error);
  }
};

export const deleteFavorite = (id) => async (dispatch) => {
  try {
    const user = store.getState()?.userReducer?.user;
    const { data: comment } = await API.get(`api/comments/${id}`, {
      params: {
        populate: {
          favoredBy: true,
        },
      },
    });
    const currentFavorites =
      comment?.data?.attributes?.favoredBy?.data?.map((f) => f?.id) ?? [];
    await API.put(`api/comments/${id}`, {
      data: {
        favoredBy: currentFavorites?.filter((f) => +f !== +user.id),
      },
    });
    dispatch({ type: "REMOVE_FAVORITE", payload: id });
  } catch (error) {
    console.log(error);
  }
};

export const resetFavorites = () => async (dispatch) =>
  dispatch({ type: "RESET_FAVORITES" });
